import React, { useEffect, useState } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import EmailLoginForm from './EmailLoginForm';
import LoginWIthOtpForm from './LoginWIthOtpForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginMethodSwitcher from './LoginMethodSwitcher';
import { LoginFormProps } from '../../shared/types';
import { useThemeMode } from '../../../../contexts/ThemeProvider';
import { useAuth } from '../../../../contexts/AuthProvider';

const LoginForm = ({ authLogic, config }: LoginFormProps) => {
  const { login } = useAuth();
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  const [showError, setShowError] = useState(false);

  const { loginMode, errors, isLoading, handleSubmit, LOGIN_MODES } = authLogic;

  const loginConfig = config?.login || {};

  useEffect(() => {
    if (errors.general) {
      setShowError(true);
      const timer = setTimeout(() => {
        setShowError(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [errors.general]);

  const onSubmit = async (event: any) => {
    event.preventDefault();
    const result = await handleSubmit(event);

    if (result.success) {
      switch (result.type) {
        case 'login':
          const { user, accessToken } = result.data;

          const authUser = {
            id: user.id,
            email: user.email,
            phone: user.phone,
            name: user.name,
            role: user.role,
            status: 'active'
          };

          login(authUser, accessToken);
          break;

        case 'otp_sent':
          console.log('OTP sent successfully');
          break;

        case 'reset_sent':
          console.log('Reset email sent successfully');
          break;
      }
    }
  };

  return (
    <>
      {loginMode === LOGIN_MODES.FORGOT_PASSWORD ? (
        <ForgotPasswordForm authLogic={authLogic} config={config} />
      ) : (
        <>
          {errors.general && showError && (
            <Alert 
              severity="error" 
              sx={{ 
                mb: 3,
                width: '100%',
                borderRadius: 2,
                backgroundColor: isDark ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.08)',
                border: isDark ? '1px solid rgba(244, 67, 54, 0.3)' : '1px solid rgba(211, 47, 47, 0.2)',
                color: isDark ? '#ffcdd2' : '#c62828',
                '& .MuiAlert-icon': {
                  color: isDark ? '#ef5350' : '#d32f2f'
                }
              }}
            >
              {errors.general}
            </Alert>
          )}

          <Box component="form" onSubmit={onSubmit} autoComplete="on" noValidate sx={{ width: '100%' }}>
            {loginMode === LOGIN_MODES.EMAIL && <EmailLoginForm authLogic={authLogic} config={config} />}
            {loginMode === LOGIN_MODES.EMAILWITHOTP && <LoginWIthOtpForm authLogic={authLogic} config={config} />}
            <LoginMethodSwitcher authLogic={authLogic} config={config} />
          </Box>
        </>
      )}
    </>
  );
};

export default LoginForm;